import React, { useState } from "react";
import { SimpleTable } from "../../ui/SimpleTable/SimpleTable";
import { ConfirmDialog } from "../../ConfirmDialog/ConfirmDialog";
import { useFetchAllTypeWastes } from "../../../../../hooks/guide/useFetchAllTypeWastes";
import { TypeWastes } from "../../../../../types/api/guide/typeWastes.types";
import { typeWastesService } from "../../../../../services/guide/typeWastes-service";
import { WasteTypesAddModal } from "../../ui/EntityModal/WasteTypesAddModal";
import useAppSnackbar from "../../../../../hooks/useAppSnackbar";

interface WasteTypesTableProps {
    title: string;
}

export const WasteTypesTable = ({ title }: WasteTypesTableProps) => {
    const { data: typeWastes, refetch } = useFetchAllTypeWastes();
    const { showSuccess, showError, SnackbarComponent } = useAppSnackbar();
    const [toDelete, setToDelete] = useState<TypeWastes | null>(null);
    const [openModal, setOpenModal] = useState<{ isOpen: boolean; id?: string }>({
        isOpen: false,
        id: undefined,
    });

    const handleDelete = async (id: string) => {
        try {
            await typeWastesService.delete(id);
            showSuccess("Успешное удаление")
            refetch();
        } catch (e) {
            showError(e.response.data);
            console.log("Ошибка при удалении типа отходов");
        }
    };

    return (
        <>
            <SimpleTable<TypeWastes>
                title={title}
                columns={[{ key: "name", title: "Название" }]}
                data={typeWastes}
                enableSearchByName
                getRowKey={(r) => r.id}
                getRowActions={(row) => ({
                    onEdit: () => setOpenModal({ isOpen: true, id: row.id }),
                    onDelete: () => setToDelete(row),
                })}
                emptyText="Справочник пуст"
                setOpen={() => setOpenModal({ isOpen: true, id: undefined })}
            />

            <ConfirmDialog
                open={!!toDelete}
                title="Удалить тип отходов?"
                description={toDelete ? `Будет удалён: ${toDelete.name}` : undefined}
                onCancel={() => setToDelete(null)}
                onConfirm={() => {
                    if (!toDelete) return;
                    handleDelete(toDelete.id);
                    setToDelete(null);
                }}
            />

            {openModal.isOpen && (
                <WasteTypesAddModal
                    key={openModal.id ?? "create"}
                    id={openModal.id}
                    onClose={() => setOpenModal({ isOpen: false, id: undefined })}
                    refetchData={refetch}
                />
            )}
            <SnackbarComponent/>
        </>
    );
};
